import { motion } from "framer-motion";

/**
 * Gate 2 · Surface-Based Editing (LOCKED 2026-02) — first-entry area picker.
 *
 * Founder-locked heading: "Choose a part of your home".
 * Renders `areas` from the backend catalogue — never hard-coded here.
 * Selecting an area calls `onPick(areaSlug)`, after which the workspace
 * transitions to the parts-of-your-home experience.
 *
 * Mental Model Fit — Colour Workspace:
 *   1. Choose an area  ← THIS component
 *   2. Choose a part of your home
 *   3. Choose a colour
 *   4. Apply
 *   5. Render
 */
export default function AreaPickerEntryCard({ areas, onPick }) {
  return (
    <div
      className="min-h-[420px] flex items-center justify-center"
      data-testid="workspace-area-picker"
    >
      <div className="w-full max-w-xl bg-white rounded-3xl shadow-soft border border-brand-border p-8 lg:p-10">
        <div className="text-center mb-8">
          <div className="overline text-brand-teal mb-2">Colour Workspace</div>
          <h2 className="font-serif text-3xl text-brand-ink">
            Choose a part of your home
          </h2>
          <p className="text-sm text-brand-muted mt-3">
            Pick the area you&rsquo;re colouring. You can switch anytime.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3">
          {(areas || []).map((a, i) => (
            <motion.button
              key={a.slug}
              type="button"
              onClick={() => onPick(a.slug)}
              data-testid={`area-tile-${a.slug}`}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.05 }}
              whileTap={{ scale: 0.97 }}
              className="group h-24 rounded-2xl border-2 border-brand-border bg-white hover:border-brand-teal hover:bg-brand-linen/40 transition-all inline-flex flex-col items-center justify-center gap-1.5 p-3"
            >
              <span className="text-2xl leading-none" aria-hidden="true">{a.icon}</span>
              <span className="text-sm font-semibold text-brand-ink">{a.display_name}</span>
            </motion.button>
          ))}
        </div>

        {(!areas || areas.length === 0) && (
          <p className="text-xs text-brand-muted text-center mt-6">
            Loading the areas of your home&hellip;
          </p>
        )}
      </div>
    </div>
  );
}
